import { Injectable } from '@angular/core';

export interface ReportsDestination {
  path: string;
  external: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReportsNavigationService {
  private static readonly INTERNAL_REPORTS_PATH = '/reports';
  private static readonly EXTERNAL_REPORTS_PATH = '/spriced-reports';

  getDestination(
    hostname: string,
    applicationUrl: string,
    homeUrl?: string,
  ): ReportsDestination {
    const isDvmHostname = /(^|[.-])enc(?=[.-]|$)/i.test(hostname);

    if (isDvmHostname) {
      return {
        path: ReportsNavigationService.INTERNAL_REPORTS_PATH,
        external: false,
      };
    }

    const environmentHomeUrl = (homeUrl || applicationUrl).trim().replace(/\/+$/, '');

    return {
      path: `${environmentHomeUrl}${ReportsNavigationService.EXTERNAL_REPORTS_PATH}`,
      external: true,
    };
  }
}
